// extracted by mini-css-extract-plugin
export default {"message":"WarningModal-module__message--LjENL","btns":"WarningModal-module__btns--cTApE","btn-confirm":"WarningModal-module__btn-confirm--rZlpI"};